import React from 'react'
import StartButton from './StartButton'

const Section4 = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center pt-3 pb-5 mb-5 scroll-fade-in">
        <h2>You ready?</h2>
        <p className='text-center px-4 mb-2'>Once you nail a good foundation in Melee, leveling up in other areas will come easier.</p>
        <p className='text-center px-4'>Let's get started.</p>
        <StartButton />
    </div>
  )
}

export default Section4